import { render, staticRenderFns } from "./PlatformMobileTopBar.vue?vue&type=template&id=56de47ec&scoped=true"
import script from "./PlatformMobileTopBar.vue?vue&type=script&lang=js"
export * from "./PlatformMobileTopBar.vue?vue&type=script&lang=js"
import style0 from "./PlatformMobileTopBar.vue?vue&type=style&index=0&id=56de47ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de47ec",
  null
  
)

export default component.exports